import { renderMaintenanceInfo } from '@neptune/maintenance-info-shell';
import { isOnPremiseDeployment } from 'common/deploymentModes';

if (!isOnPremiseDeployment()) {
  renderMaintenanceInfo();
}
